<template>
  <section class="t-rest" aria-labelledby="guia-tramites-restricciones-title">
    <h2 id="guia-tramites-restricciones-title" class="t-rest__title">
      Restricciones y consideraciones importantes
    </h2>

    <ul class="t-rest__items">
      <li v-for="aviso in avisos" :key="aviso.label" class="t-rest__item">
        <img :src="warningIcon" alt="" aria-hidden="true">
        <p><strong>{{ aviso.label }}</strong> {{ aviso.text }}</p>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import warningIcon from '../../../assets/tramites-figma/icon-warning.svg'

const avisos = [
  {
    label: 'Incremento:',
    text: 'Aplica exclusivamente para la etapa de integrante y está sujeto a precalificación de ingresos y un límite máximo de $500,000.00.'
  },
  {
    label: 'Facturación:',
    text: 'Solo se pueden emitir facturas dentro del mes y posterior a la solicitud de alta. Existen regímenes no deducibles (como 605 Sueldos y Salarios, 607 Enajenación o Adquisición de Bienes, 608 Demás ingresos, 610 Residentes en el Extranjero, 611 Dividendos, 614 Intereses, y 615 Premios). Consulta previamente si te encuentras en alguno de ellos.'
  }
]
</script>

<style scoped>
.t-rest { display: flex; flex-direction: column; gap: var(--ds-space-5); }

.t-rest__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.t-rest__items { display: flex; flex-direction: column; gap: var(--ds-space-4); margin: 0; padding: 0; list-style: none; }
.t-rest__item { display: flex; align-items: center; gap: var(--ds-space-3); border-radius: 4px; }
.t-rest__item img { flex: 0 0 24px; width: 24px; height: 24px; }
.t-rest__item p { margin: 0; color: var(--ds-text-body); font-size: 16px; line-height: 24px; }
.t-rest__item strong { font-weight: 600; }
</style>
